export default __webpack_public_path__ + "static/media/special-icon.83349144.webp";